/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 3/14/2019.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {FormattedMessage, injectIntl} from 'react-intl';
import {Button, Modal} from '@scuf/common';
import TreeSelector from '../common/TreeSelector'
import AssetFormSimple from "../admin/assets/AssetFormSimple";
import {removeHierarchyRootIfNecessary} from "../utils/Helpers";
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";


class AssetTreeSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            createAssetModalOpen: false,
            assetSearch: '',
        }

        this.assetCreated = this.assetCreated.bind(this)
        this.closeCreateAssetModal = this.closeCreateAssetModal.bind(this)

    }

    getAssetHierarchyOptions() {
        const {hierarchy} = this.props
        const tree = removeHierarchyRootIfNecessary(hierarchy)
        return tree.map(f => {
            return this.getHierarchyItem(f, false)
        })
    }

    getHierarchyItem(item, selectable) {
        let subItems = []
        if (item.subFleets && item.subFleets.length > 0) {
            subItems = subItems.concat(item.subFleets.map(f => {
                return this.getHierarchyItem(f, false)
            }))
        }
        if (item.assets && item.assets.length > 0) {
            subItems = subItems.concat(item.assets.map(a => {
                return this.getHierarchyItem(a, true)
            }))
        }
        return {
            id: selectable ? (item.id) : ('fleet ' + item.id),
            name: item.name,
            selectable: selectable,
            items: subItems,
        }
    }

    assetCreated(asset) {
        this.setState({assetSearch: ''})
        this.props.assetCreated(asset)
        this.closeCreateAssetModal()
    }

    closeCreateAssetModal() {
        this.setState({createAssetModalOpen: false})
    }

    getCreateAssetComponent(hierarchy) {
        if (this.state.assetSearch.length === 0) {
            return null
        }


        //if there is exactly one exactly matching selectable nodes, do not display create component
        let selectableItems = hierarchy.map((i) => {
            return this.getSelectableItems(i);
        })
        selectableItems = [].concat.apply([], selectableItems)
        if (selectableItems.filter(i => i.name.toLowerCase() === (this.state.assetSearch.toLowerCase())).length === 1) {
            return null
        }

        return (
            <div className="create-asset-footer">
                <Button type="link" onClick={() => this.setState({createAssetModalOpen: true})} >
                    <FormattedMessage id="fault.report.asset.new"/> {this.state.assetSearch.length > 0 ? '\'' + this.state.assetSearch + '\'' : ''}
                </Button>
            </div>
        )
    }

    getSelectableItems(item) {
        let items = []
        if (item.selectable) {
            items.push(item)
        }
        if (item.items) {
            items = items.concat(...item.items.map(i => this.getSelectableItems(i)))
        }
        return items
    }

    render() {
        const {intl, naming, hdaUser, hierarchy} = this.props

        let localHierarchy;
        if (hdaUser) {
            localHierarchy = hierarchy.map(a => {
                return {
                    id: a.id,
                    name: a.name,
                    selectable: true,
                    items: [],
                }
            })
        }
        else {
            localHierarchy = this.getAssetHierarchyOptions()
        }
        const createAsset = this.getCreateAssetComponent(hierarchy)

        let localNaming = "fault.report.selectAsset";
        if (naming != null) {
            localNaming = naming
        }

        const footer = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ?
            null
            :
            createAsset

        return (
            <React.Fragment>
                <TreeSelector
                    placeholder={intl.formatMessage({id:localNaming})}
                    singleSelection={true}
                    tree={localHierarchy}
                    initExpandAll={true}
                    searchChanged={(value) => this.setState({assetSearch: value})}
                    search={this.state.assetSearch}
                    footer={footer}
                    {...this.props}
                />
                <Modal closeIcon={true} onClose={this.closeCreateAssetModal} open={this.state.createAssetModalOpen} closeOnDimmerClick={true} className="create-asset-modal">
                    <Modal.Content>
                        <AssetFormSimple afterCreate={this.assetCreated}
                                         onCancel={this.closeCreateAssetModal}
                                         initNameValue={this.state.assetSearch}/>
                    </Modal.Content>
                </Modal>
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
    }
}

export default injectIntl(withRouter(connect(mapStateToProps)(AssetTreeSelector)))